<!-- Not sure if all those div tags can be removed, they used to contain the ngIfs -->
@if (operationField) {
  <div>
    @switch (operationField.input_type) {
      @case (FieldInputType.INLINE) {
        <div>
          @for (subField of operationField.sub_fields; track subField; let i = $index) {
            @if (setValueObject[operationField.name]) {
              <app-edit-field-inline-field
                [displayRequiredIndication]="displayRequiredIndication"
                [subFieldIndex]="i"
                [sectionsContainer]="sectionsContainer"
                [object]="setValueObject[operationField.name]"
                [field]="subField"
                [index]="0"
                [parentIndex]="myParentIndex"
                [grandparentIndex]="myParentIndex"
              ></app-edit-field-inline-field>
            }
          }
          @if (field.name === 'operation_delete_value') {
            <div class="warn-delete">
              <div class="warn-delete__container">
                <mat-icon class="warn-delete__icon">
                  warning
                </mat-icon>
              </div>

              <div class="warn-delete__container">
                <span class="warn-delete__title">
                  {{ 'TRANS__META_OPERATION__DELETE_WARNING__HEADER' | translate }}
                </span>

                <span clasS="warn-delete__subtitle">
                  {{ operationField.field_title }} {{ 'TRANS__META_OPERATION__DELETE_WARNING' | translate }}
                </span>
              </div>
            </div>
          }
        </div>
      }
      @case (FieldInputType.INLINE_ARRAY) {
        <div>
          <app-edit-field-inline-array
            [displayRequiredIndication]="displayRequiredIndication"
            [sectionsContainer]="sectionsContainer"
            [object]="setValueObject"
            [field]="operationField"
            [grandparentIndex]="myParentIndex"
            [parentIndex]="myParentIndex"
          ></app-edit-field-inline-array>
        </div>
      }
      @default {
        <div>
          <app-edit-field
            [displayRequiredIndicaton]="displayRequiredIndication"
            [sectionsContainer]="sectionsContainer"
            [object]="setValueObject"
            [field]="operationField"
            [index]="0"
            [grandparentIndex]="myParentIndex"
            [parentIndex]="myParentIndex"
          ></app-edit-field>
        </div>
      }
    }
  </div>
}
